var window=global;var $CLJS=require("./cljs_env.js");
'use strict';$CLJS.PH=require("moment");module.exports=$CLJS.PH;